import React from 'react';
import {
  Grid,
  Box,
  Typography,
  Stepper,
  Step,
  StepLabel,
  StepContent,
  Container,
} from '@mui/material';
import { useStyles } from './styles';
import useIsMobile from 'hooks/useIsMobile';
import LazyLoad from 'react-lazyload';

export default function StepsSection({ title, labels }) {
  const classes = useStyles();
  const isMobile = useIsMobile();

  const renderStepIcon = ({ icon }) => {
    return <div className={classes.stepIcon}>{icon}</div>;
  };

  return (
    <Box px={6} py={6} className={classes.root}>
      <Container>
        <LazyLoad offset={100}>
          <Typography className={classes.subTitle} variant="h2" gutterBottom={true}>
            {title}
          </Typography>

          <Grid container={true} spacing={2} alignItems="center">
            <Grid item={true} xs={12} md={6}>
              <video
                autoPlay
                loop
                muted
                width={isMobile ? '90%' : 590}
                style={{ borderRadius: '12px' }}
              >
                <source src="/videos/new-header-banner-new-workspace.webm" type="video/webm" />
                Your browser does not support the video tag.
              </video>
            </Grid>

            <Grid item={true} xs={12} md={6}>
              <Stepper className={classes.stepper} activeStep={-1} orientation="vertical">
                {labels.map((label, index) => (
                  <Step key={index}>
                    <StepLabel
                      classes={{ label: classes.stepLabel }}
                      StepIconComponent={renderStepIcon}
                    >
                      {label}
                    </StepLabel>
                    <StepContent></StepContent>
                  </Step>
                ))}
              </Stepper>
            </Grid>
          </Grid>
        </LazyLoad>
      </Container>
    </Box>
  );
}
